// src/adminComponents/BottomNav.js
import React from "react";
import { NavLink } from "react-router-dom";
import "../styles/BottomNav.css";

const BottomNav = () => (
  <div className="bottom-nav-container">
    <nav
      className="bottom-nav-dock bottom-nav-dock-standard"
      style={{
        borderRadius: "26px",
        maxWidth: "420px",
      }}
    >
      <div className="bottom-nav-items" style={{ padding: "8px 12px" }}>
        <NavLink
          to="/admin/dashboard"
          className={({ isActive }) => `bottom-nav-tab ${isActive ? "active" : ""}`}
        >
          <span>
            <i className="fi fi-rr-dashboard"></i>
          </span>
          <div>Dashboard</div>
        </NavLink>

        <NavLink
          to="/admin/contactus"
          className={({ isActive }) => `bottom-nav-tab ${isActive ? "active" : ""}`}
        >
          <span>
            <i className="fi fi-rr-headset"></i>
          </span>
          <div>Support</div>
        </NavLink>

        <NavLink
          to="/admin/shared"
          className={({ isActive }) => `bottom-nav-tab ${isActive ? "active" : ""}`}
        >
          <span>
            <i className="fi fi-rr-lock"></i>
          </span>
          <div>Approvals</div>
        </NavLink>
      </div>
    </nav>
  </div>
);

export default BottomNav;
